import { Typography } from "antd";

const { Text } = Typography;

export function ErrorText() {
  return <Text type="danger">Something Went Wrong</Text>;
}
